import React from "react";
import style from "./style.scss";

export default ( { title, links, fullLink, logo, background, linkBackgroundColor, linkTextColor } ) => {
	const { title : titleStyle, elogo, img, links : linkStyle, wrap, center } = style;
	const isCenter = 0 === links.length;
	const section = (
		<section className={wrap} style={{ backgroundImage : `url("${background}")` }}>
			<div className={titleStyle}>
				{title}
			</div>
			{logo && <div className={`${elogo} ${isCenter ? center : ''}`}>
				<img className={img} src={logo} alt={title} />
			</div>}
			<ul className={linkStyle}>
				{links.map( ( { label, url, target } ) => (
					<li className={style.link}>
						<a href={url} target={target}>
							<span style={{ color : linkTextColor || null}}>{label}</span>
							<div className={style.linkBackground} style={{ backgroundColor: linkBackgroundColor || null }}/>
						</a>
					</li>
				) )}
			</ul>
		</section>
	);

	if ( fullLink ) {
		return (
			<a href={fullLink}>
				{section}
			</a>
		)
	}

	return section;
}



// WEBPACK FOOTER //
// ./components/banner/index.js